import { widgetService } from '@ai/widget/src/api/services/widget.service';
import { api } from '../axios';

class SseService {
  private baseUrl = '/platform/api/v1/events';

  setSseConnection = (connectionId: string): EventSource => {
    return new EventSource(`${widgetService.rootOrigin}${this.baseUrl}/${connectionId}`);
  };

  subscribeToActiveDialogs = async (connectionId: string) =>
    await api.put(`${this.baseUrl}/${connectionId}/subscribe/dialog/active`);

  subscribeToDialog = async (connectionId: string, dialogId: string) =>
    await api.put(
      `${widgetService.rootOrigin}${this.baseUrl}/${connectionId}/subscribe/dialog/${dialogId}`,
    );
}

export const sseService = new SseService();
